<template>
   
    -  {{ this.$store.state.login.tokenLogin }} -
    <textarea id="adjustable-textarea" class="w-full  p-2 border border-gray-300 rounded   text-xs
    focus:outline-none focus:ring-2 focus:ring-blue-500 text " v-model="this.fs2"></textarea>
  
   <button  @click="getdataendpoint();" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Buscar  </button>
</template>
<script>

import axios from "axios";
 
export default {
    data: function () {
        return {
            fs2: '',
            apiKey: ''
        }
    },
    mounted() {

      
      this.apiKey=this.$store.state.login.tokenLogin 

    },
    methods: {
        async getdataendpoint() {
          
            const data = {
                idUnit: 1101,
                tsi: "2025-05-05 12:41:29",
                tsf: "2025-05-05 14:41:29",
                granularity: ''
            };

            try {
                const response = await axios.post("/api/mon/getUnitData", data, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.apiKey
                    }
                });

                const sensores = response.data?.payload?.sensors;

                if (!Array.isArray(sensores) || sensores.length === 0) {
                    console.warn("No se encontraron sensores.");
                    this.result_mediciones = false;
                    return;
                }


                this.fs2 = JSON.stringify(sensores, null, 2);


                this.result_mediciones = true;
                this.valor_recibido = sensores;
                console.log("Sensores recibidos:", sensores);

            } catch (error) {
                console.error("Error al obtener datos:", error);
                this.result_mediciones = false;
            }
        }
    }
}
</script>